const initialState = {
  windMarker: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_WIND_MARKER':
      return { ...state, windMarker: action.payload };
    default:
      return state;
  }
};

export default reducer;
